import { apiRequest } from '../Api/ApiRequest';

export function api_getTicketList(status) {

  return apiRequest({
    url: `/tickets${status !== undefined ? `?status=${status}` : ''}`,
    method: 'get',
    headers: {
      Authorization: `bearer ${localStorage.getItem('hso-api-token')}`,
  },
  }).then(
    resp => resp,
  ).catch(
    error => error,
  );

}

export function getTicket(props) {

  // TODO: change to /tickets once the API is updated
  return apiRequest({
    url: `/tickets/${props}`,
    method: 'get',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    resp => resp.data,
  ).catch(
    error => error,
  );

}

export function updateTicket(ticketId, update) {

  // TODO: change to /tickets once the API is updated
  return apiRequest({
    url: `/tickets/${ticketId}/reply`,
    method: 'post',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
    data: {
      updateText: update,
    },
  }).then(
    resp => resp.data,
  ).catch(
    error => error,
  );

}

export function createTicket(props) {

  // TODO: change to /tickets once the API is updated
  return apiRequest({
    url: '/tickets',
    method: 'post',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
    data: props,
  }).then(
    resp => resp,
  ).catch(
    error => error,
  );

}

export function api_getTicketActivity(ticketId, activityId) {

  // TODO: change to /tickets once the API is updated
  return apiRequest({
    url: `/tickets/${ticketId}/activities/${activityId}`,
    method: 'get',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    resp => resp,
  ).catch(
    error => error,
  );

}
